import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "countryContainer" }
const _hoisted_2 = {
  class: "row",
  id: "country_mixed",
  style: {}
}
const _hoisted_3 = { class: "itemcard single-pricing-table" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "pricing-amount" }
const _hoisted_7 = { class: "monthly_price" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "$")
], -1)
const _hoisted_9 = {
  class: "price",
  id: "price"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "subscription" }, " /Month ", -1)
const _hoisted_11 = { class: "pricing-content" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Purchase")

import { state, getData } from '@/composables/premium-proxies';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

getData('mixed');

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).cards, (card, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["col-md-12 col-xs-12", [_unref(state).cards.length >= 4 ? 'col-lg-3' : 'col-lg-4']]),
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(card.title) + " proxies", 1),
            _createElementVNode("a", {
              href: card.url
            }, [
              _createElementVNode("img", {
                src: card.imgUrl,
                alt: ""
              }, null, 8, _hoisted_5)
            ], 8, _hoisted_4),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", _hoisted_9, _toDisplayString(card.price ? card.price : '-'), 1),
                _hoisted_10
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                class: "pricing-btn blue-btn",
                to: `/purchase?type=new_datacenter_shared&proxies=${card.abr}&title=${parseInt(
                card.title.replace(/\s+/g, '')
              )}`
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ])
        ], 2))
      }), 128))
    ])
  ]))
}
}

})